import { createFileRoute } from '@tanstack/react-router'
import { statusQuery } from '~/features/integrations/queries'
import { Gate, RouteError } from '~/features/integrations/shared'
import { mayAny } from '~/features/org/guard'
import { SourcesPage } from '~/features/integrations/SourcesPage'

const SEE = ['integrations.manage', 'matches.plan'] as const

export const Route = createFileRoute('/_app/verein/datenquellen/')({
  loader: async ({ context }) => {
    if (await mayAny(context.queryClient, [...SEE])) await context.queryClient.ensureQueryData(statusQuery())
  },
  component: () => (
    <Gate anyOf={[...SEE]}>
      <SourcesPage />
    </Gate>
  ),
  errorComponent: RouteError,
})
